import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { gu_v_spacing } from 'stylesheets/emotion/layout';
function marginTop(multiplier) {
    return css `
		> * + * {
			margin-top: ${gu_v_spacing * multiplier}px;
		}
	`;
}
const gapSizing = {
    normal: 1,
    large: 2,
};
export default function Rows({ gap = 'normal', children, }) {
    return _jsx("div", { css: marginTop(gapSizing[gap]), children: children });
}
